"use strict";
exports.__esModule = true;
exports.ANCHOR_ORIGIN = void 0;
var VERTICAL = {
    top: 'top-6',
    bottom: 'bottom-6'
};
var HORIZONTAL = {
    right: 'right-6',
    left: 'left-6'
};
var ANCHOR_ORIGIN = function (_a) {
    var vertical = _a.vertical, horizontal = _a.horizontal;
    return "".concat(VERTICAL[vertical], " ").concat(HORIZONTAL[horizontal]);
};
exports.ANCHOR_ORIGIN = ANCHOR_ORIGIN;
//# sourceMappingURL=snackbar.style.js.map